
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/product/[slug]",
      function () {
        return require("private-next-pages/[region]/[lang]/product/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/product/[slug]"])
      });
    }
  